import { ReactComponent as ChevronDown } from "./chevron-down.svg";

const ChevronDownIcon: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
> = (props) => <ChevronDown {...props} />;

export default ChevronDownIcon;
